module.exports = __webpack_public_path__ + "img/power.693dd204.svg";